import { Grid } from '@mui/material';
import React, { useEffect, useState } from "react";
import "src/components/Testing/testing.css";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import CancelIcon from "@mui/icons-material/Cancel";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import {useAlertContext} from "src/hooks/use-alert";
import { Resizable } from "re-resizable";

const icons = [
  <ReportProblemIcon sx={{ fill: "rgb(255, 564, 253) !important" }} />,
  <CancelIcon />,
  <CheckCircleIcon />,
];
const AlertCard = ({ alert }) => (
  <div className="alert-card">
    <div className="alertCardIcon">
      {/* {icons[Math.floor(Math.random() * icons.length)]}{" "} */ alert.icon}
      {/* select a random icon name */}
      <p>n°{alert.details}</p>
    </div>
    <div className="alertCardContent">
      <div>
        <h4>{alert.title}</h4>
      </div>
      <p>position: {alert.position} </p>
      <p>Date: {alert.date}</p>
      <p>
        tipo:{alert.type} value:{alert.value}
      </p>
    </div>
  </div>
);

var boxStyle1;
var boxStyle2;

export const AlertGrid = ({ searchedAlerts }) => {
  const { events } = useAlertContext();
  const [alerts, setAlerts] = useState([]);
  useEffect(() => {
    setAlerts(events.data);
  }, [events.data]);
  const [drag, setDrag] = useState({
    identifire: null,
    active: false,
    x: "",
    y: "",
  });

  const [dims, setDims] = useState([
    {
      w: 0,
      h: 0,
    },
    {
      w: 0,
      h: 0,
    },
  ]);

  const [n, setN] = useState({
    w: 9,
    h:  Math.round(365 / 65.75),
  });

  const startResize = (e, n) => {
    setDrag({
      identifire: n,
      active: true,
      x: e.clientX,
      y: e.clientY,
    });
  };

  const resizeFrame = (e) => {
    const { identifire, active, x, y } = drag;
    var index = identifire - 1;
    if (active) {
      const xDiff = Math.abs(x - e.clientX);
      const yDiff = Math.abs(y - e.clientY);
      const newW =
        x > e.clientX ? dims[index].w - xDiff : dims[index].w + xDiff;
      const newH =
        y > e.clientY ? dims[index].h - yDiff : dims[index].h + yDiff;
      setDrag({ ...drag, x: e.clientX, y: e.clientY });
      const newDims = dims.map((d, i) => {
        if (i === index) {
          //  update dims of right container
          return { w: newW, h: newH };
        } else {
          // The rest haven't changed
          return d;
          // return { w: `-webkit-calc(100% - ${newW}px)`, h: d.h };
        }
      });
      setDims(newDims);
      setN({
        w: Math.round(Math.abs(newW) / 300),
        h: Math.round(Math.abs(newH) / 65.75),
      });
    }
  };

  const stopResize = (e) => {
    setDrag({ ...drag, active: false, x: e.clientX, y: e.clientY });
  };

  // switch (drag.identifire) {
  //   case 1:
  //     boxStyle1 = {
  //       width: dims[0].w === 0 ? `auto` : `${dims[0].w}px`,
  //       height: dims[0].h === 0 ? `fit-content` : `${dims[0].h}px`,
  //     };
  //     break;
  //   case 2:
  //     boxStyle2 = {
  //       width:
  //         dims[1].w === 0
  //           ? `-webkit-calc(100% - ${dims[0].w}px)`
  //           : `${dims[1].w}px`,
  //       height: dims[1].h === 0 ? `fit-content` : `${dims[1].h}px`,
  //     };
  //     break;
  //   default:
  //     boxStyle1 = {
  //       width: dims[0].w === 0 ? `auto` : `${dims[0].w}px`,
  //       height: dims[0].h === 0 ? `fit-content` : `${dims[0].h}px`,
  //     };
  //     boxStyle2 = {
  //       width: dims[1].w === 0 ? `-webkit-fill-available` : `${dims[1].w}px`,
  //       height: dims[1].h === 0 ? `fit-content` : `${dims[1].h}px`,
  //     };
  //     break;
  // }

  const style = {
    // display: "flex",
    // alignItems: "center",
    // justifyContent: "center",
    border: "solid 1px #ddd",
    margin: "5px",
    background: "#f0f0f0",
  };

  return (
    // <Fragment>
    //   <div
    //     className="container"
    //     // onMouseMove={(e) => resizeFrame(e)}
    //     // onMouseUp={(e) => stopResize(e)}
    //   >
        <Resizable
        className="resizebleContainer"
          style={style}
          defaultSize={{
            width: "auto",
            height: "fit-content",
          }}
          // onMouseDown={(e) => startResize(e, 1)}
        >
          <Grid container>
            {/* {alerts.slice(n.h === 0 ? alerts.length : -n.h).map((alert) => ( */}
            {alerts.map((alert) => (
              <Grid key={alert.id} item>
                <div className="alert-row">
                  <div className="alertCardIcon">{alert.icon}</div>
                  {/* <p>n°{alert.details}</p> */}
                  <h4>{alert.title}</h4>
                  <p>position: {alert.position} </p>
                  <p>Date: {alert.date}</p>
                  <p>
                    tipo:{alert.type} value:{alert.value}
                  </p>
                </div>
              </Grid>
            ))}
          </Grid>
        </Resizable>
        /* <div id="resaizeContainer1" className="box" style={boxStyle1}>
          <button className="dragger" onMouseDown={(e) => startResize(e, 1)}>
            Size Me
          </button>
          <div className="alert-grid">
            <Grid container>
              {alerts
                .slice(-(n.w * n.h) === 0 ? alerts.length : -(n.w * n.h))
                .map((alert) => (
                  <Grid key={alert.id} item md={4}>
                    <AlertCard alert={alert} />
                  </Grid>
                ))}
            </Grid>
          </div>
        </div> */
        /* <div id="resaizeContainer2" className="box" style={boxStyle2}>
          <button className="dragger" onMouseDown={(e) => startResize(e, 2)}>
            Size Me
          </button>
          <div className="alert-grid">
            <Grid container>
              {alerts
                .slice(-(n.w * n.h) === 0 ? alerts.length : -(n.w * n.h))
                .map((alert) => (
                  <Grid key={alert.id} item md={4}>
                    <AlertCard alert={alert} />
                  </Grid>
                ))}
            </Grid>
          </div>
        </div> */
      // </div>
      /* <div
        className="container"
        onMouseMove={(e) => resizeFrame(e, 2)}
        onMouseUp={(e) => stopResize(e, 2)}
      >
        
      </div> */
    // </Fragment>
  );
};

const AlertSearch = ({ alerts, setSearchResults }) => {
  const handleSearch = (e) => {
    const searchQuery = e.target.value.toLowerCase();
    const results = alerts.filter(
      (alert) =>
        alert.title.toLowerCase().includes(searchQuery) ||
        alert.details.toLowerCase().includes(searchQuery)
    );
    setSearchResults(results);
  };
  return (
    <div className="alert-search">
      <input
        type="text"
        placeholder="Search alerts..."
        onChange={handleSearch}
      />
    </div>
  );
};

const AlertApp = () => {
  const { events } = useAlertContext();
  // const [alerts, setAlerts] = useState(alert.events);
  // useEffect(() => {
  //   setAlerts(alert.events);
  // }, [alert.events]);

  // var i = 0;
  // var events = alert.events.map((event) => {
  //   return {
  //     id: i++,
  //     title: event,
  //     date: "2022-03-14",
  //     details: "This is alert " + i,
  //   };
  // });

  const [searchResults, setSearchResults] = useState(events.data);

  return (
    <div className="alert-app">
          <AlertSearch
            alerts={events.data}
            setSearchResults={setSearchResults}
          />
          <AlertGrid alerts={searchResults} />
    </div>
  );
};

export default AlertGrid;

// [
//     {
//       id: 1,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-14",
//       details: "This is alert 1",
//     },
//     {
//       id: 2,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-15",
//       details: "This is alert 2",
//     },
//     {
//       id: 3,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-16",
//       details: "This is alert 3",
//     },
//     {
//       id: 4,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-16",
//       details: "This is alert 4",
//     },
//     {
//       id: 5,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-16",
//       details: "This is alert 5",
//     },
//     {
//       id: 6,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-02-16",
//       details: "This is alert 6 df",
//     },
//     {
//       id: 7,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-04-16",
//       details: "This is alert 7",
//     },
//     {
//       id: 8,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-20",
//       details: "This is alert 8",
//     },
//     {
//       id: 9,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 10,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 11,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 12,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 13,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 14,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//     {
//       id: 15,
//       title: 'Henderson Von changed Description to "digital optical deposit"',
//       date: "2022-03-18",
//       details: "This is alert 9",
//     },
//   ]

const AlertContainer = ({ alerts, setSearchResults }) => {
  const [drag, setDrag] = useState({
    active: false,
    x: "",
    y: "",
  });

  const [dims, setDims] = useState({
    w: 200,
    h: 200,
  });

  const boxStyle = {
    width: `${dims.w}px`,
    height: `${dims.h}px`,
  };

  const startResize = (e) => {
    setDrag({
      active: true,
      x: e.clientX,
      y: e.clientY,
    });
  };

  const resizeFrame = (e) => {
    const { active, x, y } = drag;
    if (active) {
      const xDiff = Math.abs(x - e.clientX);
      const yDiff = Math.abs(y - e.clientY);
      const newW = x > e.clientX ? dims.w - xDiff : dims.w + xDiff;
      const newH = y > e.clientY ? dims.h + yDiff : dims.h - yDiff;

      setDrag({ ...drag, x: e.clientX, y: e.clientY });
      setDims({ w: newW, h: newH });
    }
  };

  const stopResize = (e) => {
    setDrag({ ...drag, active: false });
  };

  return (
    <div className="container" onMouseMove={resizeFrame} onMouseUp={stopResize}>
      <div className="box" style={boxStyle}>
        <Grid container>
          {alerts.map((alert) => (
            <Grid key={alert.id} item md={4}>
              <AlertCard alert={alert} />
            </Grid>
          ))}
        </Grid>
        <button className="dragger" onMouseDown={startResize}>
          Size Me
        </button>
      </div>
    </div>
  );
};
